export default "__VITE_ASSET__DIY2YhJU__"